<template>
  <v-container style="width: 100%;">
    <v-layout justify-space-between>
      <h1>Fixed Price Trips</h1>
      <v-btn @click="create" color="green" dark class="text-none">Create Fixed Cost Trip</v-btn>
    </v-layout>
    <v-layout pt-3 justify-center>
      <v-flex xs12 md8>
        <SimpleCard>
          <FixedCostList :fixedCosts="fixedCosts"/>
        </SimpleCard>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
// @ is an alias to /src
import Overview from "@/components/settings/Overview.vue";
import FixedCostList from "@/components/settings/pricing/FixedCostList.vue";
import SimpleCard from "@/components/widget/SimpleCard";

import axios from "axios";
axios.defaults.withCredentials = true;

export default {
  name: "fixed_pricing",
  components: {
    Overview,
    SimpleCard,
    FixedCostList
  },
  data: function() {
    return {
      fixedCosts: []
    };
  },
  methods: {
    create: function() {
      this.$router.push("/settings/pricing/fixed_cost/create");
    }
  },
  mounted: async function() {
    try {
      var url = `${this.$store.state.apiUrl}/fixed_cost/all`;

      let response = await axios.get(url, {
        params: {}
      });

      this.fixedCosts = response.data;
    } catch (error) {
      this.loading = false;
      console.log("Failed to get history");
    }
  }
};
</script>
